module.exports = __webpack_public_path__ + "img/electric-car.37fda74d.png";